import { createRouter, createWebHistory } from "vue-router";
import { createApp } from 'vue';
import store from "@/store/index";
import ModalConfirm from "@/components/common/ModalConfirm";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import WindowPopupLayout from "@/layouts/WindowPopupLayout.vue";


const routes = [
  {
    path: "/",
    component: DefaultLayout,
    children: [
      {
        path: "/",
        name: "Home",
        component: () => import("@/views/MainPage.vue"),
      },
      { //TODO 메일 내 링크 살아있어서 redirect 처리만 해둠. 향후 삭제처리
        path: "/index.do",
        redirect: "/",
      },
      {
        path: "/join",
        name: "Join",
        component: () => import("@/views/user/JoinPage.vue"),
      },
      {
        path: "/login",
        name: "Login",
        component: () => import("@/views/common/LoginPage.vue"),
      },
      {
        path: "/admin-login",
        name: "AdminLogin",
        component: () => import("@/views/common/AdminLoginPage.vue"),
      },
      {
        path: "/find-id",
        name: "FindId",
        component: () => import("@/views/user/FindIdPage.vue"),
      },
      {
        path: "/init-pw",
        name: "InitPw",
        component: () => import("@/views/user/InitPwPage.vue"),
      },
      
      //서비스 소개
      {
        path: "/intro-duns",
        name: "IntroDuns",
        component: () => import("@/views/intro/DunsPage.vue"),
      },
      {
        path: "/intro-bir",
        name: "IntroBir",
        component: () => import("@/views/intro/BirPage.vue"),
      },
      {
        path: "/intro-compliance",
        name: "IntroCompliance",
        component: () => import("@/views/intro/CompliancePage.vue"),
      },
      {
        path: "/intro-api",
        name: "IntroApi",
        component: () => import("@/views/intro/ApiPage.vue"),
      },
      {
        path: "/intro-hoovers",
        name: "IntroHoovers",
        component: () => import("@/views/intro/HooversPage.vue"),
      },
      { //TODO 네이버 검색결과 링크 살아있어서 redirect 처리만 해둠. 향후 삭제처리
        path: "/servHoovers.do",
        redirect: "/intro-hoovers",
      },
      {
        path: "/intro-data",
        name: "IntroData",
        component: () => import("@/views/intro/DataPage.vue"),
      },
      {
        path: "/intro-ra",
        name: "IntroRa",
        component: () => import("@/views/intro/RaPage.vue"),
      },
      {
        path: "/intro-fa",
        name: "IntroFa",
        component: () => import("@/views/intro/FaPage.vue"),
      },
      {
        path: "/intro-etc",
        name: "IntroEtc",
        component: () => import("@/views/intro/EtcPage.vue"),
      },

      //서비스 신청
      {
        path: "/apply-main",
        name: "ApplyMain",
        component: () => import("@/views/apply/ApplyMainPage.vue"),
      },
      { //TODO 메일 내 링크 살아있어서 redirect 처리만 해둠. 향후 삭제처리
        path: "/serviceApply.do",
        redirect: "/apply-main",
      },
      {
        path: "/apply-duns",
        name: "ApplyDuns",
        component: () => import("@/views/apply/ApplyDunsPage.vue"),
        meta: { authRequired: true }
      },
      {
        path: "/apply-bir",
        name: "ApplyBir",
        component: () => import("@/views/apply/ApplyBirPage.vue"),
        meta: { authRequired: true }
      },
      {
        path: "/apply-result",
        name: "ApplyResult",
        component: () => import("@/views/apply/ApplyResultPage.vue"),
        meta: { authRequired: true }
      },
      {
        path: "/apply-partner",
        name: "ApplyPartner",
        component: () => import("@/views/apply/ApplyPartnerPage.vue"),
      },
      {
        path: "/service-lead",
        name: "ServiceLead",
        component: () => import("@/views/apply/ServiceLeadPage.vue"),
      },

      //고객센터
      {
        path: "/cs-notice",
        name: "CsNotice",
        component: () => import("@/views/cs/NoticePage.vue"),
      },
      {
        path: "/cs-faq",
        name: "CsFaq",
        component: () => import("@/views/cs/FaqPage.vue"),
      },
      { //TODO 네이버 검색결과 링크 살아있어서 redirect 처리만 해둠. 향후 삭제처리
        path: "/csFaq.do",
        redirect: "/cs-faq",
      },
      {
        path: "/cs-qna",
        name: "CsQna",
        component: () => import("@/views/cs/QnaPage.vue"),
        meta: { authRequired: true }
      },
      {
        // 고도화 전 url, 구글스토어에 해당 주소로 링크 걸려있어 살려놓음. 로그인필요x
        path: "/CsQna.do",
        name: "CsQnaBefore",
        component: () => import("@/views/cs/QnaPage.vue"),
      },

      //사용자
      {
        path: "/mypage",
        name: "Mypage",
        component: () => import("@/views/user/MypagePage.vue"),
        meta: { authRequired: true }
      },
      {
        path: "/mypage-usage",
        name: "MypageUsage",
        component: () => import("@/views/user/MypageUsagePage.vue"),
        meta: { authRequired: true }
      },
      {
        path: "/duns-change",
        name: "DunsChange",
        component: () => import("@/views/user/DunsChangePage.vue"),
        meta: { authRequired: true }
      },

      // 서비스 만료 안내페이지(ODC 씰 부착 스크립트 내 접근 경로)
      {
        path: "/service_expired.do",
        component: () => import("@/views/common/ServiceExpiredPage.vue"),
      },

      // 예외
      {
        path: "/404",
        name: "404",
        component: () => import("@/views/common/404.vue"),
      },
      {
        path: "/:pathMatch(.*)*",
        redirect: "/",  //TODO 고객캐시 이슈로 404에러일경우 무조건 메인으로 변경처리
      },
    ]
  },
  {
    path: "/popup",
    component: WindowPopupLayout,
    children: [
      {
        path: "estimate",
        component: () => import("@/views/popup/EstimatePage.vue"),
        meta: { authRequired: true },
      },
      {
        path: "submit-docs",  // 제출서류항목 출력용 페이지
        component: () => import("@/views/popup/SumbitDocumentTablePage.vue"),
      },
      {
        path: "banner",  // 메인 팝업 페이지
        name: "MainPopupPage",
        component: () => import("@/views/popup/PopupBanner.vue"),
      },
      {
        path: "promotion",  // 메인 팝업 페이지
        name: "MainPopupPage2",
        component: () => import("@/views/popup/PopupBanner2.vue"),
      },
    ]
  },
  {
    path: "/",
    component: WindowPopupLayout,
    children: [
      {
        // TODO 고도화 전 URL로 이미 메일로 해당 경로가 발송된 건들이 있어 살려놓음. 더이상 호출 없으면 삭제처리
        path: "servSurvey.do",
        component: () => import("@/views/common/ServiceSurveyPage.vue"),
      },
      {
        path: "service-survey",
        component: () => import("@/views/common/ServiceSurveyPage.vue"),
      },
      {
        path: "report_view.do",
        name: "reportView",
        component: () => import("@/views/common/reportView.vue"),
      },
      {
        path: "/gse/forsec/reportDownload.do",
        name: "samsungReportView",
        component: () => import("@/views/common/reportDownloadSamsung.vue"),
      },
    ]
  },
];

const router = createRouter({
  mode: "history",
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

let modalInstance = null;

let lastPvKey = null;
let pvTimer = null;

router.afterEach((to) => {
  // 연속 이동 시 중복 방지
  const key = to.fullPath;
  if (key === lastPvKey) return;
  lastPvKey = key;

  // wcs 로드/DOM 반영 타이밍 보정 + 연쇄호출 방지
  clearTimeout(pvTimer);
  pvTimer = setTimeout(() => {
    if (window.wcs) { window.wcs_do(); }
  }, 100);
});

router.beforeEach((to, from, next) => {
  window.scrollTo({ top: 0, behavior: "smooth" });

  if (typeof window !== "undefined" && typeof sessionStorage !== "undefined") {
    const GCLID_KEY = "gclid";
    const toGclid = to.query?.gclid;
    if (typeof toGclid === "string" && toGclid.length > 0) {
      sessionStorage.setItem(GCLID_KEY, toGclid);
    }
    const storedGclid = sessionStorage.getItem(GCLID_KEY);
    const hasGclid = typeof toGclid === "string" && toGclid.length > 0;

    if (!hasGclid && storedGclid) {
      next({
        ...to,
        query: { ...to.query, gclid: storedGclid },
        replace: true,
      });
      return;
    }
  }

  if (to.matched.some(routeInfo => routeInfo.meta.authRequired)) {
    const isLogin = store.getters["userStore/isLogin"];
    if (!isLogin) {
      if (!modalInstance) {
        // 모달 인스턴스가 없는 경우 생성
        const div = document.createElement("div");
        document.body.appendChild(div);

        const appInstance = createApp(ModalConfirm);
        modalInstance = appInstance.mount(div);

        modalInstance.show({
          title: "로그인 후 이용해주세요.",
          content: "로그인이 필요한 서비스입니다.<br />지금 로그인 하시겠습니까?",
          confirmButtonText: "로그인",
          cancelButtonText: "닫기",
        }).then((result) => {
          modalInstance = null;  // 모달 인스턴스 초기화
          if (result) {
            next({ name: 'Login', query: { redirect: encodeURIComponent(to.fullPath) } });
          }
        });
      } else {
        // 이미 모달 인스턴스가 존재하며 다시 보여주기 위하여 메세지만 업데이트
        modalInstance.show({
          title: "로그인 후 이용해주세요.",
          content: "로그인이 필요한 서비스입니다.<br />지금 로그인 하시겠습니까?",
          confirmButtonText: "로그인",
          cancelButtonText: "닫기",
        }).then((result) => {
          if (result) {
            next({ name: 'Login', query: { redirect: encodeURIComponent(to.fullPath) } });
          }
        });
      }
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
